import {useEffect, useRef} from 'react';
import {homepageStore} from '../store/HomepageStore';
import {reaction} from 'mobx';

export const useScrollToActiveSection = () => {
    const timer = useRef(null);
    const limitTime = useRef(null);

    useEffect(() => {
        const disposer = reaction(
            () => homepageStore.scrollToParams,
            newValue => {
                if (newValue) {
                    if (!limitTime.current) {
                        limitTime.current = Date.now() + 2000; // 2 seconds
                    }

                    timer.current = setInterval(() => {
                        const {id, blockPosition} = newValue;
                        const element = document.getElementById(id);

                        const clearTimer = () => {
                            clearInterval(timer.current);
                            limitTime.current = null;
                            homepageStore.setScrollToParams(null);
                        };

                        if (element) {
                            clearTimer();
                            requestAnimationFrame(() => {
                                element.scrollIntoView({
                                    behavior: 'smooth',
                                    block: blockPosition,
                                    inline: 'nearest'
                                });
                            });
                        }

                        if (timer.current && limitTime.current <= Date.now()) {
                            clearTimer();
                        }
                    }, 100);
                }
            }
        );

        // Cleanup function to dispose the reaction on unmount
        return () => disposer();
    }, []);
};
